const API_BASE = process.env.REACT_APP_API_BASE;

const parseErrorMessage = (data, status) => {
    if (typeof data === "object" && data !== null) {
        return data?.detail || data?.message || Object.values(data).flat().join(" ") || `Error ${status}`;
    }
    return `Error ${status}`;
};

export const registerProfessional = async ({ name, email, registration_no, professional_type, area_of_operation, turnstile_token, phone_number = "Null" }) => {
    const res = await fetch(`${API_BASE}/auth/user/professional/`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            name,
            email,
            phone_number,
            registration_no: registration_no.trim().toUpperCase(),
            professional_type,
            area_of_operation,
            turnstile_token: "String",
        }),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
        throw new Error(parseErrorMessage(data, res.status));
    }

    return data;
};
